/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

function Table5({ setFieldValue }) {
  const [data, setData] = useState({
    muc1: [
      {
        id: uuidV4(),
        value2: 2017,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
      {
        id: uuidV4(),
        value2: 2018,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
      {
        id: uuidV4(),
        value2: 2019,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
      {
        id: uuidV4(),
        value2: 2020,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
      {
        id: uuidV4(),
        value2: 2021,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
    ],
    muc2: [
      {
        id: uuidV4(),
        value2: 2017,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
      {
        id: uuidV4(),
        value2: 2018,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
      {
        id: uuidV4(),
        value2: 2019,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
      {
        id: uuidV4(),
        value2: 2020,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
      {
        id: uuidV4(),
        value2: 2021,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
    ],
  });

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleChangeValue = (type, id, name, value) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>STT</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Năm phát sinh lỗ</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số lỗ phát sinh</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Số lỗ đã chuyển đến trong các kỳ tính thuế trước
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Số lỗ được chuyển trong kỳ tính thuế này
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Số lỗ còn được chuyển sang các kỳ tính thuế sau
              </Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
            </tr>
            <tr>
              {/* <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
              >
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td> */}
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}>I</Td>
              <Td
                style={{ textAlign: "left", background: "#ddeff3", fontWeight: "bold" }}
                colSpan="5"
              >
                Lỗ của hoạt động sản xuất kinh doanh được chuyển trong kỳ
              </Td>
            </tr>
            {data.muc1.map((item, index) => (
              <tr key={index}>
                <Td style={{ textAlign: "center" }}>{index + 1}</Td>
                <Td style={{ textAlign: "center" }}>{item.value2}</Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    type="number"
                    rowType="muc1"
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value6}
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
                colSpan="2"
              >
                Tổng cộng
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}>II</Td>
              <Td
                style={{ textAlign: "left", background: "#ddeff3", fontWeight: "bold" }}
                colSpan="5"
              >
                Lỗ của hoạt động chuyển nhượng bất động sản được chuyển trong kỳ
              </Td>
            </tr>
            {data.muc2.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc2", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center" }}>{item.value2}</Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    rowType="muc2"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    type="number"
                    rowType="muc2"
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                    rowType="muc2"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value6}
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
                colSpan="2"
              >
                Tổng cộng
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(Table5);

function InputTable(props) {
  const { onChange, type = "text", name, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id, rowType });
    } else if (type === "date") {
      onChange({ value, name, type, id, rowType });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id, rowType });
    }
  }
  return (
    <input
      name={name}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
